import { render, staticRenderFns } from "./lawyer_sever_list.vue?vue&type=template&id=377f6ace&scoped=true"
import script from "./lawyer_sever_list.vue?vue&type=script&lang=js"
export * from "./lawyer_sever_list.vue?vue&type=script&lang=js"
import style0 from "./lawyer_sever_list.vue?vue&type=style&index=0&id=377f6ace&prod&scoped=true&lang=less"
import style1 from "./lawyer_sever_list.vue?vue&type=style&index=1&id=377f6ace&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f6ace",
  null
  
)

export default component.exports